import * as React from "react";
import { I18N_NS } from "Config/i18n";
import { withTranslation, WithTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";

const priorityMap: { [key in API_QUESTION_PRIORITY]: { icon: IconName; color: string; label: string } } = {
  LOW: { icon: "angle-double-down", color: "#17c833", label: "low" },
  NORMAL: { icon: "angle-up", color: "#ffc800", label: "normal" },
  HIGH: { icon: "angle-double-up", color: "#f44006", label: "high" },
};

export const PriorityLabel = withTranslation(I18N_NS.PROJECT)(
  ({ type, t }: { type: API_QUESTION_PRIORITY } & WithTranslation) => {
    if (priorityMap[type]) {
      return (
        <span>
          <FontAwesomeIcon
            icon={["fas", priorityMap[type].icon]}
            fixedWidth={true}
            style={{ marginRight: "10px", color: priorityMap[type].color }}
          />
          <span style={{ textTransform: "capitalize" }}>{t(priorityMap[type].label)}</span>
        </span>
      );
    } else {
      return null;
    }
  }
);

export const PriorityIcon: React.FunctionComponent<{ type: API_QUESTION_PRIORITY }> = ({ type }) => {
  return (
    <FontAwesomeIcon
      icon={["fas", priorityMap[type].icon]}
      fixedWidth={true}
      style={{ color: priorityMap[type].color }}
    />
  );
};
